if (!customElements.get('sp-halloween-price')) {
  customElements.define('sp-halloween-price', class extends HTMLElement {
    connectedCallback() {
      this.start = Date.parse(this.dataset.start);
      this.end = Date.parse(this.dataset.end);
      this.updatePrice = this.updatePrice.bind(this);
      this.updatePrice();
      this.timer = setInterval(this.updatePrice, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    updatePrice() {
      const now = Date.now();
      const active = now >= this.start && now < this.end;
      const regular = this.querySelector('[data-sp-regular]');
      const sale = this.querySelector('[data-sp-sale]');
      if (regular && sale) {
        regular.hidden = active;
        sale.hidden = !active;
      }
    }
  });
}
